import defaultsDeep from 'lodash/defaultsDeep';

const DEFAULTS = {
  features: {
    metrics: {
      /**
             * Log usage metrics to google analytics
             */
      enabled: true
    },
    promoCode: {
      enabled: false,
      endpoints: null,
      displayCopy: false
    },
    bestAvailableLink: {
      enabled: false,
      url: null,
      labelButton: 'Best Available Seats',
      labelText: 'Choose Best Available Seats',
      labelSelect: 'Or choose Best Available Seats'
    },
    levelSelector: {
      enabled: false,

      /**
             * If enabled a choose best available button will be shown.
             * The current performance ID will be prepended to the URL.
             *
             * e.g. bestAvailableUrl: '/booking/production/bestavailable/'
             * => '/booking/production/bestavailable/123'
             * @type {[type]}
             */
      bestAvailableUrl: null
    },
    miniMap: {
      enabled: false
    },
    panZoom: {
      enabled: true,
      options: {
        minZoom: 1,
        maxZoom: 6,
        zoomScaleSensitivity: 1
      }
    },
    customSeatDescription: {
      enabled: false,
      customiser: null
    },
    details: {
      enabled: true,
      displayTitleWebContentId: null,
      //  e.g. additionalMessageWebContentDescriptions: ['Special Notice']
      additionalMessageWebContentDescriptions: []
    },
    performanceSelector: {
      enabled: false
    },
    customGetCurrentSessionKey: {
      enabled: false
    },
    cookieGetCurrentSessionKey: {
      enabled: false,
      cookie: 'session_key'
    },
    cacheableGetSeats: {
      enabled: true
    },
    preferredPriceType: {
      enabled: true
    },
    priceFitlers: {
      enabled: true
    },
    seatKey: {
      enabled: true
    },
    viewFromSeat: {
      enabled: false,
      endpoint: null,
      showCaption: true
    },
    lockedSeats: {
      enabled: true,
      lockedPriceTypes: []
    },
    orphanSeats: {
      enabled: false,
      leaveSingleSeatsWebContentDescription: null
    },
    filterPriceTypes: {
      enabled: false,
      options: {
        modesOfSale: {
          regular: null,
          subscriber: null
        },
        priceTypes: {
          regular: [],
          subscriberAddOn: [],
          flexPackages: [],
          fixedPackages: []
        }
      }
    },
    inlineSeatUpsell: {
      enabled: false
    },
    adaAttestation: {
      enabled: false,
      specialRequestOptions: [],
      csiData: {},
      seatTypes: []
    },

    blackOutSeatsWithoutPrices: {
      enabled: false,
      blackoutStatus: {}
    },

    seatKeyPersistentIcons: {
      enabled: false,
      persistentIcons: []
    },

    podSeats: {
      enabled: false,
      minimum: 2,
      minimumPerZones: [],
      message: 'How many seats would you like to buy in this box?'
    }
  },

  currency: '£',
  dateTimeFormat: 'MMMM D, YYYY [at] h:mma',

  returnUrl: null,
  successUrl: '/booking/basket',

  fallbacks: {
    fallbackUrl: '/booking/basket',
    defaultMessage: 'There was an error loading select your own seat.',
    unsupportedMessage: 'Your browser does not support select your own seat'
  },

  maxTicketsMessage: 'You cannot select any more seats.',

  /**
     * Provide custom max tickets limit
     * Will use the value from GetMaxTicketAmount if not set
     */
  customMaxTicketsLimit: false,

  facilityMapping: [],

  basket: {
    label: 'Cart',
    totalLabel: 'Total',
    submitLabel: 'Add to cart',
    successLabel: 'Success',
    updateLabel: 'Update cart',
    processingLabel: 'Processing',
    existingMessage: 'This seat is in your cart',
    extraMessages: [
      'Seats are not reserved until they have been added to your cart.'
    ]
  },

  seatTypes: {
    /**
         * Default types, defines config for seat types
         * Available options:
         *
         *
         * label - Label used in the key
         * id: - Unique ID used to identify the icon
         * slug - Used for CSS class applied to the seat
         * method - Either 'default' or 'custom'
         * customName - If method is 'custom' defines which icon to use, must match layer name
         * holdCodes - Array of hold code id's icon will be used for matching seats
         * seatTypeIds - Array of seat status id's icon will be used for matching seats
         */
    defaultTypes: [
      {
        label: 'Available',
        id: 'regularSeat',
        slug: 'available',
        method: 'default',
        customName: null,
        holdCodes: [],
        seatTypeIds: []
      },
      {
        label: 'Selected',
        id: 'selectedSeat',
        slug: 'selected',
        method: 'default',
        customName: null,
        holdCodes: [],
        seatTypeIds: []
      },
      {
        label: 'Occupied',
        id: 'unavailableSeat',
        slug: 'unavailable',
        method: 'default',
        customName: null,
        holdCodes: [],
        seatTypeIds: []
      }
    ],

    customTypes: [],

    // Hidden/blacked-out status code.
    hiddenStatusCodes: ['BLK'],

    // Seat mappings, which icon to use for a given type/status of seat
    defaultMapping: { status: 'unavailable', draw: 'unavailableSeat' },
    seatMappings: [
      { statusCode: 'AVL', status: 'available', draw: 'regularSeat' },
      { statusCode: 'HBR', status: 'available', draw: 'regularSeat' },
      { statusCode: 'TKD', status: 'unavailable', draw: 'unavailableSeat' },
      { statusCode: 'HLD', status: 'unavailable', draw: 'unavailableSeat' }
    ]
  },

  /**
     * Custom seat messages
     * Array of possible messages to show for a seat,
     * messages can be associated with one or more seat type or hold codes
     *
     * Example format:
     * {
     *     text: 'My message',
     *     seatTypeIds: [1, 2],
     *     holdCodeIds: []
     * }
     */
  seatMessages: []
};

export default defaultsDeep(window.SYOSConfig || {}, DEFAULTS);



// WEBPACK FOOTER //
// ./src/javascripts/app/config.js